// Curated, user-facing subset of backend `Article.Type` (appquickchat/models.py).
// Only types meaningful as a *filter* in the KB UI belong here. Do NOT add
// customer-specific types (e.g. Sony) or internal types (e.g. Dynamic, Article
// content, Paragraph, Manually added, Shopify, raw file handlers like PPTX/
// XLSX/CSV/EPUB) — they will leak into every tenant's dropdown.
export enum ArticleType {
  INTERCOM = 'Intercom',
  URL = 'URL',
  ARTICLE = 'Article',
  DOCX = 'DOCX',
  PDF = 'PDF',
  YOUTUBE = 'YouTube',
}

export type ArticlesFilter = {
  types?: ArticleType[];
  tags?: string[];
  url?: string;
  title?: string;
  query?: string;
};
